import { replace as replaceHelper, getHrefLangs } from '@swegaming-ab/nuxtjs-helpers';

export default async function($prismic, path, error, documentKey = 'slug') {

    const documentHelper = findDocumentHelper(path, documentKey);

    if (documentHelper) {

        const fetchLinks = [].concat(getFetchLinks(documentHelper.pageType));

        let document = await $prismic.api.getByID(documentHelper.id, {
            fetchLinks: fetchLinks
        });

        document = replaceHelper(document, document.lang);

        return {
            document: document,
            hreflangs: getHrefLangsHelper(document, $prismic.linkResolver)
        };
    }

    return error({
        statusCode: 404,
        message: 'Not found'
    });
}

function getFetchLinks(pageType) {
    return {
        'page': 'author.avatar, author.name, author.bio',
        'post': 'author.avatar, author.name, author.bio',
    }[pageType] || [];
}

function findDocumentHelper(path, key = 'slug') {

    if (path.slice(-1) !== '/') {
        path = `${path}/`;
    }

    const documents = require('@/documents.json');
    for (const [, document] of Object.entries(documents)) {
        if (document.prismicLocale === process.env.PRISMIC_LOCALE && document[key] === path) {
            return document;
        }
    }
    return false;
}

function getHrefLangsHelper(document, linkResolver) {

    let siteConfig = require('@/config/locales.config.js').default;
    let prismics = siteConfig.map(locale => {
        return locale.prismic;
    });

    let prismicToHreflangMap = new Map();
    siteConfig.forEach(c => {
        prismicToHreflangMap.set(c.prismic, c.hreflang);
    });

    if (document.data.is_english_page) {

        // hack to set the language part of the hreflang to en if 
        // the page is english. The hreflang needs to be two part (as it always should be)
        // or it will not take effect.

        const currentHrefLang = prismicToHreflangMap.get(process.env.PRISMIC_LOCALE);
        const splittedHrefLang = currentHrefLang.split('-');

        if (splittedHrefLang.length == 2) {
            prismicToHreflangMap.set(process.env.PRISMIC_LOCALE, `en-${splittedHrefLang[1]}`);
        }
    }

    return getHrefLangs(document, linkResolver, prismics, prismicToHreflangMap);
}